import { v4 as uuidv4 } from 'uuid';
import { getDiscoverPublishersAPI } from './api';
import {
    DIRECTORY_PAGE_LIMIT,
    preparePublisherData,
    deriveDirectoryFilterIndustries,
} from './getDirectoryPublishers';

// Separate action + pool from browse mode (EBL-13117) — replaces
// searchDirectoryResults (page 1), never touches directoryPublishers, so
// clearing the search box reveals the browse list exactly as it was.
// Named distinctly from that field: withActions() assigns this function
// onto `this` by its own name, and would silently clobber a same-named
// data field otherwise.
async function searchDirectoryPublishers(query) {
    this.observed.directoryPublishersSearching = true;
    try {
        const session = this.env.session;
        const traceId = this.env.traceId;

        const res = await getDiscoverPublishersAPI({
            token: session?.token,
            traceId,
            page: 1,
            limit: DIRECTORY_PAGE_LIMIT,
            search: query,
        });

        // Out-of-order network responses: a faster typer can fire a second
        // search before this one's response lands, and there's no
        // guarantee they resolve in the order they were sent. Bail out if
        // the live search text has since moved on from this call's query,
        // so a stale response — success or failure — can't clobber
        // whatever the newer, still-in-flight search eventually resolves to.
        if (query !== this.search.searchText.trim()) return;

        if (!res?.data) {
            // Don't leave a previous, unrelated query's results on screen
            // under a search box that now reads something else.
            this.searchDirectoryResults = [];
            this.observed.searchDirectoryResults = uuidv4();
            this.applyDirectoryFilter();
            return;
        }

        const data = res.data?.data || res.data;
        const publishers = data?.publishers || [];
        const colored = preparePublisherData(publishers, this.whatshotPublishers);

        this.searchDirectoryResults = colored;
        this.searchQuery = query;
        this.searchPage = 1;
        this.searchHasMore = !!data?.hasNextPage;
        this.directoryFilterIndustries = deriveDirectoryFilterIndustries(colored);
        this.observed.searchDirectoryResults = uuidv4();
        this.applyDirectoryFilter();
    } finally {
        this.observed.directoryPublishersSearching = false;
    }
}

export default searchDirectoryPublishers;
